export function debug(...messages) {
  const isDebugMode = window.location.hostname.includes("localhost");
  if (!isDebugMode) {
    return;
  }
  console.log(...messages);
}
